import DomainPanel, { Content } from "components/domainPanel/DomainPanel";
import moment from "moment";
import { memo } from "react";
import DomainDetails from "types/domainDetails";

interface TakenDomainBodyProps {
  domainDetails: DomainDetails;
}

const TakenDomainBody = (props: TakenDomainBodyProps) => {
  const { domainDetails } = props;

  const creationDate = domainDetails.creation
    ? moment(domainDetails.creation)
    : undefined;

  const expirationDate = domainDetails.expires
    ? moment(domainDetails.expires)
    : undefined;

  const content: Content[] = [
    {
      title: "Registered On",
      description: creationDate?.format("DD MMMM YYYY"),
    } as unknown as Content,
    {
      title: `Expires On`,
      description: expirationDate?.format("DD MMMM YYYY"),
    } as unknown as Content,
  ];

  return <DomainPanel title={"Registration Details"} details={content} />;
};

export default memo(TakenDomainBody);
